import LayoutActividad from "../../../components/LayoutActividad";
import Imagen1 from "../../../images/modulo1/nombres.png";
import Imagen2 from "../../../images/modulo1/apellidos.png";
import Imagen3 from "../../../images/modulo1/edades.png";
import Imagen4 from "../../../images/modulo1/adultos.png";
import Imagen5 from "../../../images/modulo1/lugares.png";
import Imagen6 from "../../../images/modulo1/idiomas.png";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faSignLanguage } from "@fortawesome/free-solid-svg-icons";
import { modulo1 } from "../../../routes/Module1";
import Sidebar from "../Sidebar";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo1/Actividad7.mp3";

const Actividad7 = () => {
  const infoUnidad = modulo1.content[0];
  const infoAct = modulo1.content[0].activities[6];
  const crumbs = [
    {
      title: modulo1.title,
      url: "/" + modulo1.url,
    },
    {
      title:
        modulo1.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo1.content[0].activities[7].name}`,
    linkNext: `${modulo1.url}/${modulo1.content[0].path}/${modulo1.content[0].activities[7].path}`,
    titlePrev: `${modulo1.content[0].activities[5].name}`,
    linkPrev: `${modulo1.url}/${modulo1.content[0].path}/${modulo1.content[0].activities[5].path}`,
  };
  const metadata = {
    color: modulo1.color,
    title: `${modulo1.title} - ${infoAct.name}`,
    name: modulo1.title
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo1.color} hat-text`}>
          <FontAwesomeIcon icon={faSignLanguage} /> Hacemos
        </small>
      </p>

      <h2 className="mb-5">Actividad 7</h2>
      <AudioPlayer track={Audio} />

      <ul>
        <li>Completa estos datos con ayuda de tu familia.</li>
      </ul>
      <div className="row mt-5 align-items-center">
        <div className="col-md-4 col-xs-12">
          <img src={Imagen1} alt="Familia" />
        </div>
        <div className="col-md-5 col-xs-12">
          <div>
            <p>Mi nombre:</p>
            <textarea className="form-control" rows={2} />
          </div>
        </div>
      </div>
      <div className="row my-3 align-items-center">
        <div className="col-md-4 col-xs-12">
          <img src={Imagen2} alt="Familia" />
        </div>
        <div className="col-md-5 col-xs-12">
          <div>
            <p>Mi apellido:</p>
            <textarea className="form-control" rows={2} />
          </div>
        </div>
      </div>
      <div className="row my-3 align-items-center">
        <div className="col-md-4 col-xs-12">
          <img src={Imagen3} alt="Familia" />
        </div>
        <div className="col-md-5 col-xs-12">
          <div>
            <p>Mi edad:</p>
            <textarea className="form-control" rows={2} />
          </div>
        </div>
      </div>
      <div className="row my-3 align-items-center">
        <div className="col-md-4 col-xs-12">
          <img src={Imagen4} alt="Familia" />
        </div>
        <div className="col-md-5 col-xs-12">
          <div>
            <p>Nombre de los adultos que me cuidan:</p>
            <textarea className="form-control" rows={2} />
          </div>
        </div>
      </div>
      <div className="row my-3 align-items-center">
        <div className="col-md-4 col-xs-12">
          <img src={Imagen5} alt="Familia" />
        </div>
        <div className="col-md-5 col-xs-12">
          <div>
            <p>De qué lugar del Perú viene mi familia:</p>
            <textarea className="form-control" rows={2} />
          </div>
        </div>
      </div>
      <div className="row my-3 align-items-center">
        <div className="col-md-4 col-xs-12">
          <img src={Imagen6} alt="Familia" />
        </div>
        <div className="col-md-5 col-xs-12">
          <div>
            <p>Qué idiomas hablan mis familiares:</p>
            <textarea className="form-control" rows={2} />
          </div>
        </div>
      </div>

      <GuiaDocente>
        <p>
          Lea las indicaciones. Lea los datos que se deben llenar. Ayude a
          completar los datos. Aproveche para destacar la diversidad como una
          riqueza y no como un problema.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad7;
